import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import {currentDateAndTime, formatDateWithTime } from '../../Constants/Constants';
import * as XLSX from 'xlsx';
import PageTitle from '../../Components/PageTitle';
import { TextBox } from '../../Components/InputElements';


const GeoLocationHistory = () => {

    const { apiURL, apiHeaderJson} = useContext(ConfigContext);
    
    const [companyOptions, setCompanyOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    
    const [filter, setFilter] = useState({
        from_date: null,
        to_date: null,
        location: null,
        department: null,
        companyId: null,
        request_status: null,
    });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);

    const statusOptions = [
        {value: "1", label: "Success"},
        {value: "2", label: "Not Found"},
        {value: "3", label: "Failed"},
        {value: "4", label: "Lat,Lng Not Capture"},
    ]

    const getCompanies = () => {
            const headers = apiHeaderJson;
            // console.log("headers =>",headers);
            axios.get(`${apiURL}CompanyMasters/getCompanies`, {
                params: {
                }, headers
            }).then((response) => {
                let data = response.data;
                // console.log(data);
                if (response.data.success === true) {
                    let rows = data?.companies?.map((val,idx) => {
                        return  { value: val?.company_id, label: val?.company_name }
                    });
                    setCompanyOptions(rows);
                    
                } else {
                    console.error("Error fetching list");
                }
            }).catch((error) => {
                console.error("error", error);
            });
        }

        // states
        // departments
        // locations
        // designations
        // grades
        // EmployeeCategory
        // EmployeeType

    const getMasterList = (company_id) => {
        const headers = apiHeaderJson;
        // console.log("EmploymentMasterList => apiURL",apiURL);
        // console.log("EmploymentMasterList => apiHeaderJson",apiHeaderJson);
        axios.get(`${apiURL}ReportRouter/EmploymentMasterList`,
            {
                params: {
                    company_id: company_id || filter?.companyId,
                    locations:true,
                    departments: true,
                    date: currentDateAndTime(),
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                console.log("getMasterList => EmploymentMasterList", data);
                if (data?.success === true) {
                    const tempLocation = data?.data?.location_list?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    const tempDepartment = data?.data?.department_list?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    setDepartment(tempDepartment)
                    setLocation(tempLocation);
                }
            });
    };
    useEffect(() => {
        getCompanies();
        // getMasterList();
    }, []);
    
    useEffect(() => {
        if(isChanged){
            getCompanies();
            setIsChanged(false);
        }
    }, [isChanged]);

    const handleDateChange=(e)=>{
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        })
    }
    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
    };
  
    const handleExcelDownload = async () => {
        const headers = apiHeaderJson;
    
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        axios.get(`${apiURL}ReportRouter/GetGeoLoacationHistory`, {
            params: {
                company_id: filter?.companyId,
                from_date: filter?.from_date,
                to_date: filter?.to_date,
                department_id: filter?.department,
                location_id: filter?.location,
                request_status: filter?.request_status,
                date: currentDateAndTime(),
            },
            headers
        })
        .then(async (response) => {
            const { success, data, message } = response.data;
    
            if (success === true) {
                // Assuming `data` is an array of objects (representing rows of data)
                const filteredData = data.slice(0); // Use this if you need to remove specific rows
    
                // Explicitly set the headers based on the object keys (remove the index row)
                const headers = Object.keys(filteredData[0]);
    
                // Convert the filtered data to a worksheet without auto-indexing
                const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });
    
                // Create a new workbook and append the worksheet
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, worksheet, 'Geo Location Report');
    
                // Format the current date and time
                const date = new Date();
                const dateString = date.toLocaleDateString();
            
                // Save the file with the correct format
                XLSX.writeFile(wb, `Geo Location Report (${formatDateWithTime()?.split(" ")[0]}).xlsx`);
    
                Swal.close();
                Swal.fire({
                    title: `<strong>Success</strong>`,
                    text: message,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,

                });
            } else {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
        })
        .catch((error) => {
            Swal.close();
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: error.response ? error.response.message : error.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
    }
    
    const handleClearAll = () => {
        setFilter({
            from_date: "",
            to_date: "",
            location: null,
            department: null,
            location_shift_id: null,
            companyId: null,
            request_status: null,
        });
    }

    return (
        <div>
            <div class="main-content">
                <div class="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Geo-Location History`} primary={`Home`} />
                        <div className="card">
                            <div className="card-body">
                                <div className="row gy-4">
                                    <div style={{ backgroundColor: "#FAFAFA", borderRadius: "5px" }} className="card-header">
                                        <div className="row">
                                            <div className=' col-md-3 position-relative mb-5'>
                                                {/* <div className=" mx-3 mt-2 mb-1 "> */}
                                                    <label className="form-label" >Select Company</label>
                                                    <div className=' position-absolute z-2 w-100 pe-3' >
                                                        <Select
                                                            onChange={(selectedOption) => { setIsChanged(true); setFilter({ ...filter, companyId: selectedOption?.value }); getMasterList(selectedOption?.value) }}
                                                            placeholder={`Select Company`}
                                                            options={companyOptions}
                                                            value={filter?.companyId ? companyOptions.find(option => option.value == filter?.companyId) : null}
                                                        />
                                                    </div>
                                                    {/* {errors.companyId && <div className="text-danger">{errors.companyId}</div>} */}
                                                {/* </div> */}
                                            </div>
                                            {/* <div className='col-md-3'>
                                                <label htmlFor="Location" className="form-label" > Select Month </label>
                                                <Select
                                                    options={monthOptions}
                                                    value={
                                                        filter?.month
                                                            ? monthOptions.find(option => option.value === filter?.month)
                                                            : null
                                                    }
                                                    onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                                    placeholder={`Select Month`} />
                                            </div> */}
                                            <div className="col-md-3">
                                                <TextBox
                                                type="Date"
                                                id="from_date"
                                                name="from_date"
                                                label="From Date"
                                                value={filter?.from_date}
                                                disabled={!filter?.companyId}
                                                change={handleDateChange}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                type="Date"
                                                id="to_date"
                                                name="to_date"
                                                label="To Date"
                                                value={filter?.to_date}
                                                disabled={!filter?.from_date}
                                                change={handleDateChange}
                                                />
                                            </div>

                                            <div className="col-md-3 ">
                                                <div>
                                                    <label className="form-label" >Department</label>
                                                    <Select
                                                        onChange={(selectedOption) => {setFilter({ ...filter, department: selectedOption?.value })}}
                                                        placeholder={filter?.from_date || filter?.to_date ? "All" : "Select Department"}
                                                        options={department}
                                                        isDisabled={!filter?.from_date || !filter?.to_date}
                                                        value={filter?.department ? department.find(option => option.value == filter?.department) : null}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3 ">
                                                <label className="form-label" > Location </label>
                                                <Select
                                                    onChange={(selectedOption) => {setFilter({ ...filter, location: selectedOption?.value })}}
                                                    placeholder={filter?.from_date && filter?.to_date ? "All" : "Select Location"}
                                                    options={location}
                                                    isDisabled={!filter?.from_date || !filter?.to_date}
                                                    value={filter?.location ? location.find(option => option.value == filter?.location) : null}
                                                />
                                            </div>
                                            <div className="col-md-3 ">
                                                <label className="form-label" >Status</label>
                                                <Select
                                                    onChange={(selectedOption) => {setFilter({ ...filter, request_status: selectedOption?.value })}}
                                                    placeholder="All"
                                                    options={statusOptions}
                                                    isDisabled={!filter?.from_date || !filter?.to_date}
                                                    value={filter?.request_status ? statusOptions.find(option => option.value == filter?.request_status) : null}
                                                />
                                            </div>
                                            {/* <div className='col-md-2' >
                                                <div>
                                                    <label>Apply Filter</label>
                                                </div>
                                                <button type="button" onClick={handleFilter}
                                                    className={`btn btn-info btn-label waves-effect waves-light ${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''}`}>
                                                    <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                    Filter
                                                </button>
                                            </div> */} 
                                            <div style={{ width: "15%" }} className='col-md-2'>
                                                <div>
                                                    <label>Export Excel</label>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={handleExcelDownload}
                                                    disabled={loading}
                                                    className={`${(!filter?.companyId || !filter?.from_date || !filter?.to_date && !filter?.department && !filter?.location) ? 'disabled' : ''} btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                                    <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                    {!loading ? "Export Excel" : "Loading..."}
                                                </button>
                                            </div>
                                            <div style={{ width: "10%" }} className='col-md-2'>
                                                <div> <label>Clear Filter</label> </div>
                                                <button type="button"
                                                    disabled={loading}
                                                    className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!filter?.companyId && !filter?.from_date && !filter?.to_date && !filter?.department && !filter?.location) ? 'disabled' : ''}`}
                                                    onClick={handleClearAll} >
                                                    <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                            </div>

                                        </div>
                                        {/* success message */}
                                        <div style={{ width: "60%", margin: "auto" }}>
                                            {successMsg ?
                                                <div className=" position-relative alert alert-success mt-3" role="alert">
                                                    {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                </div>
                                                : null
                                            }
                                            {/* error message */}
                                            {errorMsg ?
                                                <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                    {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                </div> : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GeoLocationHistory;
